export const stringsKey = "DateTimePicker";
export const englishStrings = {
	selectDateTimeLabel: "Select Date Time",
	dateTimeRequiredErrorMessage: "The date time field is required.",
	invalidDateTimeErrorMessage: "Invalid Date or Time.",
};
